import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Badge,
  Spinner,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import * as XLSX from "xlsx";
import { v4 as uuidv4 } from "uuid";

// ============== INLINE STYLES ==============
const styles = {
  container: {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
    color: "#333",
    fontSize: "24px",
    fontWeight: "600",
  },
  globalConfigCard: {
    backgroundColor: "#f0f7ff",
    border: "2px solid #3498db",
    borderRadius: "8px",
    marginBottom: "20px",
    padding: "15px",
  },
  globalConfigTitle: {
    color: "#2980b9",
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "15px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  tabContainer: {
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
  },
  tab: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "500",
    transition: "all 0.2s",
  },
  tabActive: {
    backgroundColor: "#3498db",
    color: "#fff",
  },
  tabInactive: {
    backgroundColor: "#ecf0f1",
    color: "#7f8c8d",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#555",
    marginBottom: "4px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "14px",
    backgroundColor: "#fff",
    color: "#333",
  },
  select: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "14px",
    backgroundColor: "#fff",
    color: "#333",
    cursor: "pointer",
  },
  articleCard: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "10px",
    overflow: "hidden",
  },
  articleCardError: {
    border: "2px solid #e74c3c",
  },
  articleHeader: {
    padding: "12px 15px",
    backgroundColor: "#f8f9fa",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  articleHeaderError: {
    backgroundColor: "#fdecea",
  },
  articleBody: {
    padding: "15px",
    backgroundColor: "#fff",
  },
  badge: {
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: "500",
    marginLeft: "8px",
  },
  badgeInfo: {
    backgroundColor: "#3498db",
    color: "#fff",
  },
  badgeError: {
    backgroundColor: "#e74c3c",
    color: "#fff",
  },
  badgeColor: {
    backgroundColor: "#95a5a6",
    color: "#fff",
    marginRight: "4px",
    marginBottom: "4px",
    display: "inline-block",
  },
  button: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "14px",
    transition: "all 0.2s",
  },
  buttonPrimary: {
    backgroundColor: "#3498db",
    color: "#fff",
  },
  buttonSuccess: {
    backgroundColor: "#27ae60",
    color: "#fff",
  },
  buttonWarning: {
    backgroundColor: "#f39c12",
    color: "#fff",
  },
  buttonDanger: {
    backgroundColor: "#e74c3c",
    color: "#fff",
  },
  buttonSecondary: {
    backgroundColor: "#95a5a6",
    color: "#fff",
  },
  buttonSmall: {
    padding: "4px 10px",
    fontSize: "12px",
  },
  grid: {
    display: "grid",
    gap: "15px",
  },
  grid2: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  grid3: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  grid4: {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
  grid5: {
    gridTemplateColumns: "repeat(5, 1fr)",
  },
  grid6: {
    gridTemplateColumns: "repeat(6, 1fr)",
  },
  summaryBox: {
    backgroundColor: "#e8f4fd",
    padding: "15px",
    borderRadius: "8px",
    border: "1px solid #bee5eb",
  },
  errorAlert: {
    backgroundColor: "#f8d7da",
    color: "#721c24",
    padding: "10px 15px",
    borderRadius: "4px",
    marginBottom: "15px",
    border: "1px solid #f5c6cb",
  },
  proportionTable: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "12px",
  },
  proportionTh: {
    backgroundColor: "#f8f9fa",
    padding: "8px",
    border: "1px solid #dee2e6",
    textAlign: "center",
    fontWeight: "600",
  },
  proportionTd: {
    padding: "4px",
    border: "1px solid #dee2e6",
    textAlign: "center",
  },
  proportionInput: {
    width: "60px",
    padding: "4px",
    border: "1px solid #ddd",
    borderRadius: "3px",
    textAlign: "center",
    fontSize: "12px",
  },
  eanInput: {
    width: "90px",
    padding: "4px",
    border: "1px solid #ddd",
    borderRadius: "3px",
    fontSize: "11px",
  },
  flexRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  modalContent: {
    maxHeight: "400px",
    overflowY: "auto",
  },
  checkboxGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "10px",
  },
  checkboxItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 10px",
    backgroundColor: "#f8f9fa",
    borderRadius: "4px",
    cursor: "pointer",
  },
  applyButton: {
    padding: "6px 12px",
    backgroundColor: "#9b59b6",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "500",
  },
};

function ArticulosBulkCreate() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_BULK = import.meta.env.VITE_URL_ARTICULOS;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;

  // Input mode: 'form' or 'excel'
  const [inputMode, setInputMode] = useState("form");

  // ============== GLOBAL CONFIG STATE ==============
  const [globalConfig, setGlobalConfig] = useState({
    lineas: "",
    marcas: "",
    familias: "",
    colecciones: "",
    proveedores: "",
    ano: "",
    codigoSAT: "",
    precioEsp: "No",
    arrayColores: [],
    arrayTallas: [],
  });

  // Catalogs data
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  // Year options
  const hoy = new Date();
  const year = hoy.getFullYear() - 10;
  const years = Array.from(new Array(40), (val, index) => index + year);

  // Articles array
  const [articulos, setArticulos] = useState([createEmptyArticulo()]);
  const [expandedIndex, setExpandedIndex] = useState(0);

  // Validation and submission states
  const [validationErrors, setValidationErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  // Modals
  const [modalColores, setModalColores] = useState(false);
  const [modalTallas, setModalTallas] = useState(false);
  const [modalGlobalColores, setModalGlobalColores] = useState(false);
  const [modalGlobalTallas, setModalGlobalTallas] = useState(false);
  const [activeArticuloIndex, setActiveArticuloIndex] = useState(0);

  function createEmptyArticulo() {
    return {
      id: uuidv4(),
      codigo: "",
      nombre: "",
      costoMX: 0,
      venta: 0,
      lineas: "",
      marcas: "",
      familias: "",
      colecciones: "",
      proveedores: "",
      ano: "",
      EAN: "",
      observaciones: "NA",
      codigoSAT: "",
      codigoUnidad: "PZ",
      precioEsp: "No",
      listaPrecioPieza: 0,
      listaPrecioCorrida: 0,
      listaPrecioPaquete: 0,
      listaPrecioCaja: 0,
      listaPrecioRebajas: 0,
      arrayColores: [],
      arrayTallas: [],
      proporciones: [],
      piezasPorCaja: 0,
      isExpanded: true,
      isValid: false,
    };
  }

  // Load catalogs on mount
  useEffect(() => {
    const token = localStorage.getItem("app_token");
    const headers = { Authorization: `Bearer: ${token}` };

    Promise.all([
      axios.get(import.meta.env.VITE_URL_LINEAS, { headers }),
      axios.get(import.meta.env.VITE_URL_MARCAS, { headers }),
      axios.get(import.meta.env.VITE_URL_FAMILIAS, { headers }),
      axios.get(import.meta.env.VITE_URL_COLECCIONES, { headers }),
      axios.get(`${import.meta.env.VITE_URL_PROVEEDORES}Tipo/China`, { headers }),
      axios.get(import.meta.env.VITE_URL_COLORES, { headers }),
      axios.get(import.meta.env.VITE_URL_TALLAS, { headers }),
    ])
      .then(([lineasRes, marcasRes, familiasRes, coleccionesRes, proveedoresRes, coloresRes, tallasRes]) => {
        setLineas(lineasRes.data);
        setMarcas(marcasRes.data);
        setFamilias(familiasRes.data);
        setColecciones(coleccionesRes.data);
        setProveedores(proveedoresRes.data);
        setColores(coloresRes.data);
        setTallas(tallasRes.data);
        setCustomSizeOrder(tallasRes.data.map((t) => t.name));
      })
      .catch((err) => {
        console.error("Error loading catalogs:", err);
        Swal.fire("Error", "No se pudieron cargar los catálogos", "error");
      });
  }, []);

  // ============== GLOBAL CONFIG HANDLERS ==============
  const handleGlobalConfigChange = (field, value) => {
    setGlobalConfig((prev) => ({ ...prev, [field]: value }));
  };

  const applyGlobalConfigToAll = () => {
    const updated = articulos.map((art) => ({
      ...art,
      lineas: globalConfig.lineas || art.lineas,
      marcas: globalConfig.marcas || art.marcas,
      familias: globalConfig.familias || art.familias,
      colecciones: globalConfig.colecciones || art.colecciones,
      proveedores: globalConfig.proveedores || art.proveedores,
      ano: globalConfig.ano || art.ano,
      codigoSAT: globalConfig.codigoSAT || art.codigoSAT,
      precioEsp: globalConfig.precioEsp || art.precioEsp,
      arrayColores: globalConfig.arrayColores.length > 0 ? [...globalConfig.arrayColores] : art.arrayColores,
      arrayTallas: globalConfig.arrayTallas.length > 0 ? [...globalConfig.arrayTallas] : art.arrayTallas,
    }));
    setArticulos(updated);
    Swal.fire({
      icon: "success",
      title: "Configuración aplicada",
      text: `Se aplicó a ${articulos.length} artículos`,
      timer: 1500,
      showConfirmButton: false,
    });
  };

  const toggleGlobalColor = (colorObj, checked) => {
    if (checked) {
      setGlobalConfig((prev) => ({
        ...prev,
        arrayColores: [...prev.arrayColores, { id: colorObj._id, name: colorObj.name, prefijo: colorObj.prefijo }],
      }));
    } else {
      setGlobalConfig((prev) => ({
        ...prev,
        arrayColores: prev.arrayColores.filter((c) => c.id !== colorObj._id),
      }));
    }
  };

  const toggleGlobalTalla = (tallaObj, checked) => {
    if (checked) {
      setGlobalConfig((prev) => ({
        ...prev,
        arrayTallas: [...prev.arrayTallas, { id: tallaObj._id, name: tallaObj.name }],
      }));
    } else {
      setGlobalConfig((prev) => ({
        ...prev,
        arrayTallas: prev.arrayTallas.filter((t) => t.id !== tallaObj._id),
      }));
    }
  };

  // ============== ARTICLE HANDLERS ==============
  const handleArticuloChange = (index, field, value) => {
    const updated = [...articulos];
    updated[index] = { ...updated[index], [field]: value };

    if (field === "codigo" && !updated[index].EAN) {
      updated[index].EAN = value;
    }

    setArticulos(updated);
  };

  const handleAddArticulo = () => {
    const newArt = createEmptyArticulo();
    // Apply global config to new article
    newArt.lineas = globalConfig.lineas;
    newArt.marcas = globalConfig.marcas;
    newArt.familias = globalConfig.familias;
    newArt.colecciones = globalConfig.colecciones;
    newArt.proveedores = globalConfig.proveedores;
    newArt.ano = globalConfig.ano;
    newArt.codigoSAT = globalConfig.codigoSAT;
    newArt.precioEsp = globalConfig.precioEsp;
    newArt.arrayColores = [...globalConfig.arrayColores];
    newArt.arrayTallas = [...globalConfig.arrayTallas];

    setArticulos([...articulos, newArt]);
    setExpandedIndex(articulos.length);
  };

  const handleAddMultipleArticulos = (count) => {
    const newArts = [];
    for (let i = 0; i < count; i++) {
      const newArt = createEmptyArticulo();
      newArt.lineas = globalConfig.lineas;
      newArt.marcas = globalConfig.marcas;
      newArt.familias = globalConfig.familias;
      newArt.colecciones = globalConfig.colecciones;
      newArt.proveedores = globalConfig.proveedores;
      newArt.ano = globalConfig.ano;
      newArt.codigoSAT = globalConfig.codigoSAT;
      newArt.precioEsp = globalConfig.precioEsp;
      newArt.arrayColores = [...globalConfig.arrayColores];
      newArt.arrayTallas = [...globalConfig.arrayTallas];
      newArt.isExpanded = false;
      newArts.push(newArt);
    }
    setArticulos([...articulos, ...newArts]);
  };

  const handleRemoveArticulo = (index) => {
    if (articulos.length === 1) {
      Swal.fire("Aviso", "Debe haber al menos un artículo", "warning");
      return;
    }
    const updated = articulos.filter((_, i) => i !== index);
    setArticulos(updated);
    if (expandedIndex >= updated.length) {
      setExpandedIndex(Math.max(0, updated.length - 1));
    }
  };

  const handleDuplicateArticulo = (index) => {
    const original = articulos[index];
    const duplicate = {
      ...original,
      id: uuidv4(),
      codigo: `${original.codigo}_COPIA`,
      EAN: "",
      proporciones: original.proporciones.map((p) => ({ ...p, ean: "" })),
    };
    setArticulos([...articulos, duplicate]);
  };

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? -1 : index);
  };

  // Colors/Sizes selection for specific article
  const openColoresModal = (index) => {
    setActiveArticuloIndex(index);
    setModalColores(true);
  };

  const toggleColoresSelection = (colorObj, checked) => {
    const updated = [...articulos];
    const art = updated[activeArticuloIndex];

    if (checked) {
      art.arrayColores = [...art.arrayColores, { id: colorObj._id, name: colorObj.name, prefijo: colorObj.prefijo }];
    } else {
      art.arrayColores = art.arrayColores.filter((c) => c.id !== colorObj._id);
      art.proporciones = art.proporciones.filter((p) => p.colorId !== colorObj._id);
    }

    setArticulos(updated);
  };

  const openTallasModal = (index) => {
    setActiveArticuloIndex(index);
    setModalTallas(true);
  };

  const toggleTallasSelection = (tallaObj, checked) => {
    const updated = [...articulos];
    const art = updated[activeArticuloIndex];

    if (checked) {
      art.arrayTallas = [...art.arrayTallas, { id: tallaObj._id, name: tallaObj.name }];
    } else {
      art.arrayTallas = art.arrayTallas.filter((t) => t.id !== tallaObj._id);
      art.proporciones = art.proporciones.filter((p) => p.sizeId !== tallaObj._id);
    }

    setArticulos(updated);
  };

  // Función para sanitizar el código EAN/barcode
  // Elimina espacios, acentos y caracteres especiales que causan problemas con escáneres
  const sanitizeBarcode = (code) => {
    if (!code) return "";
    return code
      .toString()
      .normalize("NFD") // Descompone caracteres acentuados
      .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
      .replace(/[^a-zA-Z0-9]/g, "") // Solo permite alfanuméricos (sin guiones ni puntos para compatibilidad con escáneres)
      .toUpperCase()
      .trim();
  };

  // Generate EAN
  const generateEAN = (codigo, colorId, tallaId, artIndex) => {
    const art = articulos[artIndex];
    const colorObj = art.arrayColores.find((c) => c.id === colorId) || colores.find((c) => c._id === colorId);
    const colorPre = colorObj?.prefijo || "";
    const tallaObj = art.arrayTallas.find((t) => t.id === tallaId) || tallas.find((t) => t._id === tallaId);
    const tallaName = tallaObj?.name || "";
    // Sanitizar todos los componentes para evitar caracteres problemáticos
    return `${sanitizeBarcode(codigo)}${sanitizeBarcode(colorPre)}${sanitizeBarcode(tallaName)}`;
  };

  // Handle proportion change
  const handleProporcionChange = (artIndex, colorId, sizeId, field, value) => {
    const updated = [...articulos];
    const art = updated[artIndex];
    const existingIdx = art.proporciones.findIndex((p) => p.sizeId === sizeId && p.colorId === colorId);

    if (existingIdx !== -1) {
      if (field === "cantidad") {
        art.proporciones[existingIdx].cantidad = parseFloat(value) || 0;
        if (art.codigo && value > 0 && !art.proporciones[existingIdx].ean) {
          art.proporciones[existingIdx].ean = generateEAN(art.codigo, colorId, sizeId, artIndex);
        }
      } else if (field === "ean") {
        art.proporciones[existingIdx].ean = value;
      }
    } else {
      const autoEAN = field === "cantidad" && art.codigo && value > 0 ? generateEAN(art.codigo, colorId, sizeId, artIndex) : "";
      art.proporciones.push({
        sizeId,
        colorId,
        cantidad: field === "cantidad" ? parseFloat(value) || 0 : 0,
        ean: field === "ean" ? value : autoEAN,
      });
    }

    art.piezasPorCaja = art.proporciones.reduce((sum, p) => sum + (parseFloat(p.cantidad) || 0), 0);
    setArticulos(updated);
  };

  // Validate all articles
  const validateAll = () => {
    const errors = {};

    articulos.forEach((art, index) => {
      const artErrors = [];

      if (!art.codigo?.trim()) artErrors.push("Código requerido");
      if (!art.nombre?.trim()) artErrors.push("Nombre requerido");
      if (!art.costoMX && art.costoMX !== 0) artErrors.push("Costo MX requerido");
      if (!art.venta && art.venta !== 0) artErrors.push("Venta requerido");
      if (!art.lineas || art.lineas === "0") artErrors.push("Línea requerida");
      if (!art.marcas || art.marcas === "0") artErrors.push("Marca requerida");
      if (!art.familias || art.familias === "0") artErrors.push("Familia requerida");
      if (!art.colecciones || art.colecciones === "0") artErrors.push("Colección requerida");
      if (!art.proveedores || art.proveedores === "0") artErrors.push("Proveedor requerido");
      if (!art.ano || art.ano === "0") artErrors.push("Año requerido");
      if (art.arrayColores.length === 0) artErrors.push("Al menos un color");
      if (art.arrayTallas.length === 0) artErrors.push("Al menos una talla");
      if (!art.proporciones.some((p) => p.cantidad > 0)) artErrors.push("Al menos una cantidad");

      if (artErrors.length > 0) {
        errors[index] = artErrors;
      }
    });

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Format article for API
  const formatArticuloForAPI = (art) => {
    const lineasValue = lineas.find((l) => l._id === art.lineas)?.name || art.lineas;
    const marcasValue = marcas.find((m) => m._id === art.marcas)?.name || art.marcas;
    const familiasValue = familias.find((f) => f._id === art.familias)?.name || art.familias;
    const coleccionesValue = colecciones.find((c) => c._id === art.colecciones)?.name || art.colecciones;

    return {
      codigo: art.codigo,
      nombre: art.nombre,
      costoMX: parseFloat(art.costoMX) || 0,
      venta: parseFloat(art.venta) || 0,
      lineas: lineasValue,
      marcas: marcasValue,
      familias: familiasValue,
      colecciones: coleccionesValue,
      proveedores: art.proveedores,
      ano: art.ano,
      EAN: art.EAN || art.codigo,
      observaciones: art.observaciones || "NA",
      codigoSAT: art.codigoSAT || "",
      codigoUnidad: art.codigoUnidad || "PZ",
      precioEsp: art.precioEsp || "No",
      listaPrecioPieza: parseFloat(art.listaPrecioPieza) || 0,
      listaPrecioCorrida: parseFloat(art.listaPrecioCorrida) || 0,
      listaPrecioPaquete: parseFloat(art.listaPrecioPaquete) || 0,
      listaPrecioCaja: parseFloat(art.listaPrecioCaja) || 0,
      listaPrecioRebajas: parseFloat(art.listaPrecioRebajas) || 0,
      proporciones: art.proporciones
        .filter((p) => p.cantidad > 0)
        .map((p) => {
          const colorName = art.arrayColores.find((c) => c.id === p.colorId)?.name || colores.find((c) => c._id === p.colorId)?.name;
          const tallaName = art.arrayTallas.find((t) => t.id === p.sizeId)?.name || tallas.find((t) => t._id === p.sizeId)?.name;
          return {
            color: colorName,
            talla: tallaName,
            cantidad: p.cantidad,
            ean: p.ean,
          };
        }),
    };
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateAll()) {
      Swal.fire({
        icon: "warning",
        title: "Errores de validación",
        text: "Por favor corrija los errores antes de guardar",
      });
      return;
    }

    setSubmitting(true);
    setValidaBoton(false);

    try {
      const payload = {
        articulos: articulos.map(formatArticuloForAPI),
      };

      const response = await axios.post(`${URL_ARTICULOS_BULK}/bulk`, payload, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });

      if (response.data.success) {
        await axios.post(
          URL_LOGS,
          {
            tipo: "Crear Modelos Masivo",
            detalle: `${response.data.created} artículos creados`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: `${response.data.created} artículos creados exitosamente`,
        });

        setTimeout(() => {
          window.location.href = "/ListadoArticulos";
        }, 1500);
      }
    } catch (error) {
      console.error("Bulk create error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.error || "Error al crear los artículos. Ningún artículo fue creado.",
      });
      setValidaBoton(true);
    } finally {
      setSubmitting(false);
    }
  };

  // Excel Import
  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.match(/\.(xlsx|xls)$/i)) {
      Swal.fire("Error", "Solo se permiten archivos Excel (.xlsx, .xls)", "error");
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const wb = XLSX.read(evt.target.result, { type: "binary" });
        const articulosSheet = wb.Sheets["Articulos"];
        const articulosData = articulosSheet ? XLSX.utils.sheet_to_json(articulosSheet) : [];
        const proporcionesSheet = wb.Sheets["Proporciones"];
        const proporcionesData = proporcionesSheet ? XLSX.utils.sheet_to_json(proporcionesSheet) : [];

        if (articulosData.length === 0) {
          Swal.fire("Error", "No se encontraron datos en la hoja 'Articulos'", "error");
          return;
        }

        const mergedArticulos = articulosData.map((artRow) => {
          const codigo = String(artRow.codigo || artRow["codigo*"] || "").trim();
          const artProporciones = proporcionesData
            .filter((p) => String(p.codigo || p["codigo*"] || "").trim() === codigo)
            .map((p) => ({
              sizeId: String(p.talla || p["talla*"] || ""),
              colorId: String(p.color || p["color*"] || ""),
              cantidad: parseFloat(p.cantidad || p["cantidad*"] || 0),
              ean: String(p.ean_override || p.ean || ""),
              colorName: String(p.color || p["color*"] || ""),
              tallaName: String(p.talla || p["talla*"] || ""),
            }));

          const uniqueColores = [...new Set(artProporciones.map((p) => p.colorName))];
          const uniqueTallas = [...new Set(artProporciones.map((p) => p.tallaName))];

          const arrayColores = uniqueColores.map((colorName) => {
            const color = colores.find((c) => c.name === colorName);
            return color ? { id: color._id, name: color.name, prefijo: color.prefijo } : { id: colorName, name: colorName, prefijo: "" };
          });

          const arrayTallas = uniqueTallas.map((tallaName) => {
            const talla = tallas.find((t) => t.name === tallaName);
            return talla ? { id: talla._id, name: talla.name } : { id: tallaName, name: tallaName };
          });

          const proporciones = artProporciones.map((p) => {
            const colorObj = arrayColores.find((c) => c.name === p.colorName);
            const tallaObj = arrayTallas.find((t) => t.name === p.tallaName);
            return {
              colorId: colorObj?.id || p.colorName,
              sizeId: tallaObj?.id || p.tallaName,
              cantidad: p.cantidad,
              ean: p.ean || `${codigo}${colorObj?.prefijo || ""}${p.tallaName}`,
            };
          });

          const piezasPorCaja = proporciones.reduce((sum, p) => sum + (p.cantidad || 0), 0);

          return {
            id: uuidv4(),
            codigo,
            nombre: String(artRow.nombre || artRow["nombre*"] || ""),
            costoMX: parseFloat(artRow.costoMX || artRow["costoMX*"] || 0),
            venta: parseFloat(artRow.venta || artRow["venta*"] || 0),
            lineas: String(artRow.linea || artRow["linea*"] || ""),
            marcas: String(artRow.marca || artRow["marca*"] || ""),
            familias: String(artRow.familia || artRow["familia*"] || ""),
            colecciones: String(artRow.coleccion || artRow["coleccion*"] || ""),
            proveedores: String(artRow.proveedor || artRow["proveedor*"] || ""),
            ano: String(artRow.ano || artRow["ano*"] || ""),
            EAN: String(artRow.EAN || artRow.ean || codigo),
            observaciones: String(artRow.observaciones || "NA"),
            codigoSAT: String(artRow.codigoSAT || ""),
            codigoUnidad: String(artRow.codigoUnidad || "PZ"),
            precioEsp: String(artRow.precioEsp || "No"),
            listaPrecioPieza: parseFloat(artRow.listaPrecioPieza || 0),
            listaPrecioCorrida: parseFloat(artRow.listaPrecioCorrida || 0),
            listaPrecioPaquete: parseFloat(artRow.listaPrecioPaquete || 0),
            listaPrecioCaja: parseFloat(artRow.listaPrecioCaja || 0),
            listaPrecioRebajas: parseFloat(artRow.listaPrecioRebajas || 0),
            arrayColores,
            arrayTallas,
            proporciones,
            piezasPorCaja,
            isExpanded: false,
            isValid: false,
          };
        });

        if (mergedArticulos.length > 0) {
          mergedArticulos[0].isExpanded = true;
        }

        setArticulos(mergedArticulos);
        setInputMode("form");

        Swal.fire({
          icon: "success",
          title: "Excel importado",
          text: `${mergedArticulos.length} artículos cargados. Revise y ajuste antes de guardar.`,
        });
      } catch (error) {
        console.error("Excel parse error:", error);
        Swal.fire("Error", "Error al procesar el archivo Excel", "error");
      }
    };
    reader.readAsBinaryString(file);
  };

  const downloadTemplate = () => {
    const wb = XLSX.utils.book_new();

    const articulosHeaders = [
      "codigo*", "nombre*", "costoMX*", "venta*", "linea*", "marca*",
      "familia*", "coleccion*", "proveedor*", "ano*", "EAN", "codigoSAT",
      "codigoUnidad", "observaciones", "listaPrecioPieza", "listaPrecioCorrida",
      "listaPrecioPaquete", "listaPrecioCaja", "listaPrecioRebajas", "precioEsp",
    ];
    const wsArticulos = XLSX.utils.aoa_to_sheet([articulosHeaders]);
    XLSX.utils.book_append_sheet(wb, wsArticulos, "Articulos");

    const proporcionesHeaders = ["codigo*", "color*", "talla*", "cantidad*", "ean_override"];
    const wsProporciones = XLSX.utils.aoa_to_sheet([proporcionesHeaders]);
    XLSX.utils.book_append_sheet(wb, wsProporciones, "Proporciones");

    const catalogosData = [
      ["=== COLORES DISPONIBLES ==="],
      ...colores.map((c) => [c.name]),
      [""],
      ["=== TALLAS DISPONIBLES ==="],
      ...tallas.map((t) => [t.name]),
      [""],
      ["=== PROVEEDORES (usar ID o nombre exacto) ==="],
      ...proveedores.map((p) => [`${p._id} - ${p.nombre_comercial}`]),
    ];
    const wsCatalogos = XLSX.utils.aoa_to_sheet(catalogosData);
    XLSX.utils.book_append_sheet(wb, wsCatalogos, "Catalogos");

    XLSX.writeFile(wb, "plantilla_articulos_masivos.xlsx");
  };

  // Calculate totals
  const totalArticulos = articulos.length;
  const totalPiezas = articulos.reduce((sum, art) => sum + (art.piezasPorCaja || 0), 0);

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div style={styles.container}>
          <h3 style={styles.title}>Creación Masiva de Artículos</h3>

          {/* ============== GLOBAL CONFIG SECTION ============== */}
          <div style={styles.globalConfigCard}>
            <div style={styles.globalConfigTitle}>
              <i className="fas fa-cog"></i>
              Configuración Global (Aplicar a todos los artículos)
            </div>

            <div style={{ ...styles.grid, ...styles.grid6, marginBottom: "15px" }}>
              <div>
                <label style={styles.label}>Línea</label>
                <select
                  style={styles.select}
                  value={globalConfig.lineas}
                  onChange={(e) => handleGlobalConfigChange("lineas", e.target.value)}
                >
                  <option value="">-- Seleccionar --</option>
                  {lineas.sort((a, b) => a.name.localeCompare(b.name)).map((l) => (
                    <option key={l._id} value={l._id}>{l.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Marca</label>
                <select
                  style={styles.select}
                  value={globalConfig.marcas}
                  onChange={(e) => handleGlobalConfigChange("marcas", e.target.value)}
                >
                  <option value="">-- Seleccionar --</option>
                  {marcas.sort((a, b) => a.name.localeCompare(b.name)).map((m) => (
                    <option key={m._id} value={m._id}>{m.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Familia</label>
                <select
                  style={styles.select}
                  value={globalConfig.familias}
                  onChange={(e) => handleGlobalConfigChange("familias", e.target.value)}
                >
                  <option value="">-- Seleccionar --</option>
                  {familias.sort((a, b) => a.name.localeCompare(b.name)).map((f) => (
                    <option key={f._id} value={f._id}>{f.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Colección</label>
                <select
                  style={styles.select}
                  value={globalConfig.colecciones}
                  onChange={(e) => handleGlobalConfigChange("colecciones", e.target.value)}
                >
                  <option value="">-- Seleccionar --</option>
                  {colecciones.sort((a, b) => a.name.localeCompare(b.name)).map((c) => (
                    <option key={c._id} value={c._id}>{c.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Proveedor</label>
                <select
                  style={styles.select}
                  value={globalConfig.proveedores}
                  onChange={(e) => handleGlobalConfigChange("proveedores", e.target.value)}
                >
                  <option value="">-- Seleccionar --</option>
                  {proveedores.sort((a, b) => a.nombre_comercial.localeCompare(b.nombre_comercial)).map((p) => (
                    <option key={p._id} value={p._id}>{p.nombre_comercial}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.label}>Año</label>
                <select
                  style={styles.select}
                  value={globalConfig.ano}
                  onChange={(e) => handleGlobalConfigChange("ano", e.target.value)}
                >
                  <option value="">-- Seleccionar --</option>
                  {years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ ...styles.grid, gridTemplateColumns: "1fr 1fr 200px", gap: "15px", alignItems: "end" }}>
              <div>
                <label style={styles.label}>Colores Globales ({globalConfig.arrayColores.length})</label>
                <div style={styles.flexRow}>
                  <button
                    type="button"
                    style={{ ...styles.button, ...styles.buttonSuccess, ...styles.buttonSmall }}
                    onClick={() => setModalGlobalColores(true)}
                  >
                    <i className="fas fa-palette"></i> Seleccionar Colores
                  </button>
                  {globalConfig.arrayColores.map((c) => (
                    <span key={c.id} style={{ ...styles.badge, ...styles.badgeColor }}>{c.name}</span>
                  ))}
                </div>
              </div>
              <div>
                <label style={styles.label}>Tallas Globales ({globalConfig.arrayTallas.length})</label>
                <div style={styles.flexRow}>
                  <button
                    type="button"
                    style={{ ...styles.button, ...styles.buttonSuccess, ...styles.buttonSmall }}
                    onClick={() => setModalGlobalTallas(true)}
                  >
                    <i className="fas fa-ruler"></i> Seleccionar Tallas
                  </button>
                  {globalConfig.arrayTallas
                    .sort((a, b) => customSizeOrder.indexOf(a.name) - customSizeOrder.indexOf(b.name))
                    .map((t) => (
                      <span key={t.id} style={{ ...styles.badge, ...styles.badgeColor }}>{t.name}</span>
                    ))}
                </div>
              </div>
              <div>
                <button
                  type="button"
                  style={styles.applyButton}
                  onClick={applyGlobalConfigToAll}
                >
                  <i className="fas fa-sync"></i> Aplicar a Todos ({articulos.length})
                </button>
              </div>
            </div>
          </div>

          {/* ============== TABS ============== */}
          <div style={styles.tabContainer}>
            <button
              type="button"
              style={{ ...styles.tab, ...(inputMode === "form" ? styles.tabActive : styles.tabInactive) }}
              onClick={() => setInputMode("form")}
            >
              <i className="fas fa-edit"></i> Formulario
            </button>
            <button
              type="button"
              style={{ ...styles.tab, ...(inputMode === "excel" ? styles.tabActive : styles.tabInactive) }}
              onClick={() => setInputMode("excel")}
            >
              <i className="fas fa-file-excel"></i> Importar Excel
            </button>
          </div>

          {/* ============== EXCEL IMPORT ============== */}
          {inputMode === "excel" && (
            <div style={{ ...styles.grid, gridTemplateColumns: "1fr 1fr", marginBottom: "20px" }}>
              <div>
                <label style={styles.label}>Seleccionar archivo Excel</label>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleExcelUpload}
                  style={styles.input}
                />
                <small style={{ color: "#7f8c8d", fontSize: "11px" }}>
                  El archivo debe tener las hojas: "Articulos" y "Proporciones"
                </small>
              </div>
              <div style={{ display: "flex", alignItems: "flex-end" }}>
                <button
                  type="button"
                  style={{ ...styles.button, ...styles.buttonPrimary }}
                  onClick={downloadTemplate}
                >
                  <i className="fas fa-download"></i> Descargar Plantilla
                </button>
              </div>
            </div>
          )}

          {/* ============== QUICK ADD BUTTONS ============== */}
          <div style={{ marginBottom: "15px", display: "flex", gap: "10px", alignItems: "center" }}>
            <button
              type="button"
              style={{ ...styles.button, ...styles.buttonPrimary }}
              onClick={handleAddArticulo}
            >
              <i className="fas fa-plus"></i> Agregar 1
            </button>
            <button
              type="button"
              style={{ ...styles.button, ...styles.buttonPrimary }}
              onClick={() => handleAddMultipleArticulos(5)}
            >
              <i className="fas fa-plus"></i> +5
            </button>
            <button
              type="button"
              style={{ ...styles.button, ...styles.buttonPrimary }}
              onClick={() => handleAddMultipleArticulos(10)}
            >
              <i className="fas fa-plus"></i> +10
            </button>
            <span style={{ color: "#7f8c8d", fontSize: "12px", marginLeft: "10px" }}>
              (Los nuevos artículos heredan la configuración global)
            </span>
          </div>

          {/* ============== ARTICLES LIST ============== */}
          <Form onSubmit={handleSubmit}>
            {articulos.map((art, index) => (
              <div
                key={art.id}
                style={{
                  ...styles.articleCard,
                  ...(validationErrors[index] ? styles.articleCardError : {}),
                }}
              >
                <div
                  style={{
                    ...styles.articleHeader,
                    ...(validationErrors[index] ? styles.articleHeaderError : {}),
                  }}
                  onClick={() => toggleExpand(index)}
                >
                  <div style={styles.flexRow}>
                    <i className={`fas fa-chevron-${expandedIndex === index ? "down" : "right"}`}></i>
                    <strong>#{index + 1}</strong>
                    <span>{art.codigo || "(sin código)"} - {art.nombre || "(sin nombre)"}</span>
                    {art.piezasPorCaja > 0 && (
                      <span style={{ ...styles.badge, ...styles.badgeInfo }}>{art.piezasPorCaja} pzs</span>
                    )}
                    {validationErrors[index] && (
                      <span style={{ ...styles.badge, ...styles.badgeError }}>
                        <i className="fas fa-exclamation-triangle"></i> {validationErrors[index].length} errores
                      </span>
                    )}
                  </div>
                  <div style={styles.flexRow}>
                    <button
                      type="button"
                      style={{ ...styles.button, ...styles.buttonWarning, ...styles.buttonSmall }}
                      onClick={(e) => { e.stopPropagation(); handleDuplicateArticulo(index); }}
                      title="Duplicar"
                    >
                      <i className="fas fa-copy"></i>
                    </button>
                    <button
                      type="button"
                      style={{ ...styles.button, ...styles.buttonDanger, ...styles.buttonSmall }}
                      onClick={(e) => { e.stopPropagation(); handleRemoveArticulo(index); }}
                      title="Eliminar"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </div>

                {expandedIndex === index && (
                  <div style={styles.articleBody}>
                    {/* Validation errors */}
                    {validationErrors[index] && (
                      <div style={styles.errorAlert}>
                        <strong>Errores:</strong> {validationErrors[index].join(", ")}
                      </div>
                    )}

                    {/* Row 1: Basic info */}
                    <div style={{ ...styles.grid, ...styles.grid6, marginBottom: "15px" }}>
                      <div>
                        <label style={styles.label}>Código *</label>
                        <input
                          type="text"
                          style={styles.input}
                          value={art.codigo}
                          onChange={(e) => handleArticuloChange(index, "codigo", e.target.value)}
                        />
                      </div>
                      <div style={{ gridColumn: "span 2" }}>
                        <label style={styles.label}>Nombre *</label>
                        <input
                          type="text"
                          style={styles.input}
                          value={art.nombre}
                          onChange={(e) => handleArticuloChange(index, "nombre", e.target.value)}
                        />
                      </div>
                      <div>
                        <label style={styles.label}>Costo MX *</label>
                        <input
                          type="number"
                          min="0"
                          step="any"
                          style={styles.input}
                          value={art.costoMX}
                          onChange={(e) => handleArticuloChange(index, "costoMX", e.target.value)}
                        />
                      </div>
                      <div>
                        <label style={styles.label}>Venta *</label>
                        <input
                          type="number"
                          min="0"
                          step="any"
                          style={styles.input}
                          value={art.venta}
                          onChange={(e) => handleArticuloChange(index, "venta", e.target.value)}
                        />
                      </div>
                      <div>
                        <label style={styles.label}>Piezas/Caja</label>
                        <input type="number" style={{ ...styles.input, backgroundColor: "#f0f0f0" }} value={art.piezasPorCaja} disabled />
                      </div>
                    </div>

                    {/* Row 2: Categories */}
                    <div style={{ ...styles.grid, ...styles.grid6, marginBottom: "15px" }}>
                      <div>
                        <label style={styles.label}>Línea *</label>
                        <select
                          style={styles.select}
                          value={art.lineas}
                          onChange={(e) => handleArticuloChange(index, "lineas", e.target.value)}
                        >
                          <option value="0">Selecciona</option>
                          {lineas.sort((a, b) => a.name.localeCompare(b.name)).map((l) => (
                            <option key={l._id} value={l._id}>{l.name}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label style={styles.label}>Marca *</label>
                        <select
                          style={styles.select}
                          value={art.marcas}
                          onChange={(e) => handleArticuloChange(index, "marcas", e.target.value)}
                        >
                          <option value="0">Selecciona</option>
                          {marcas.sort((a, b) => a.name.localeCompare(b.name)).map((m) => (
                            <option key={m._id} value={m._id}>{m.name}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label style={styles.label}>Familia *</label>
                        <select
                          style={styles.select}
                          value={art.familias}
                          onChange={(e) => handleArticuloChange(index, "familias", e.target.value)}
                        >
                          <option value="0">Selecciona</option>
                          {familias.sort((a, b) => a.name.localeCompare(b.name)).map((f) => (
                            <option key={f._id} value={f._id}>{f.name}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label style={styles.label}>Colección *</label>
                        <select
                          style={styles.select}
                          value={art.colecciones}
                          onChange={(e) => handleArticuloChange(index, "colecciones", e.target.value)}
                        >
                          <option value="0">Selecciona</option>
                          {colecciones.sort((a, b) => a.name.localeCompare(b.name)).map((c) => (
                            <option key={c._id} value={c._id}>{c.name}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label style={styles.label}>Proveedor *</label>
                        <select
                          style={styles.select}
                          value={art.proveedores}
                          onChange={(e) => handleArticuloChange(index, "proveedores", e.target.value)}
                        >
                          <option value="0">Selecciona</option>
                          {proveedores.sort((a, b) => a.nombre_comercial.localeCompare(b.nombre_comercial)).map((p) => (
                            <option key={p._id} value={p._id}>{p.nombre_comercial}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label style={styles.label}>Año *</label>
                        <select
                          style={styles.select}
                          value={art.ano}
                          onChange={(e) => handleArticuloChange(index, "ano", e.target.value)}
                        >
                          <option value="0">Selecciona</option>
                          {years.map((y) => (
                            <option key={y} value={y}>{y}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Row 3: Colors and Sizes */}
                    <div style={{ ...styles.grid, gridTemplateColumns: "1fr 1fr", marginBottom: "15px" }}>
                      <div>
                        <label style={styles.label}>Colores ({art.arrayColores.length})</label>
                        <div style={styles.flexRow}>
                          <button
                            type="button"
                            style={{ ...styles.button, ...styles.buttonSuccess, ...styles.buttonSmall }}
                            onClick={() => openColoresModal(index)}
                          >
                            <i className="fas fa-palette"></i> Seleccionar
                          </button>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                            {art.arrayColores.map((c) => (
                              <span key={c.id} style={{ ...styles.badge, ...styles.badgeColor }}>{c.name}</span>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div>
                        <label style={styles.label}>Tallas ({art.arrayTallas.length})</label>
                        <div style={styles.flexRow}>
                          <button
                            type="button"
                            style={{ ...styles.button, ...styles.buttonSuccess, ...styles.buttonSmall }}
                            onClick={() => openTallasModal(index)}
                          >
                            <i className="fas fa-ruler"></i> Seleccionar
                          </button>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                            {art.arrayTallas
                              .sort((a, b) => customSizeOrder.indexOf(a.name) - customSizeOrder.indexOf(b.name))
                              .map((t) => (
                                <span key={t.id} style={{ ...styles.badge, ...styles.badgeColor }}>{t.name}</span>
                              ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Proportions Grid */}
                    {art.arrayColores.length > 0 && art.arrayTallas.length > 0 && (
                      <div style={{ marginTop: "15px" }}>
                        <label style={styles.label}>Proporción (Color × Talla)</label>
                        <div style={{ overflowX: "auto" }}>
                          <table style={styles.proportionTable}>
                            <thead>
                              <tr>
                                <th style={styles.proportionTh}></th>
                                {art.arrayTallas
                                  .sort((a, b) => customSizeOrder.indexOf(a.name) - customSizeOrder.indexOf(b.name))
                                  .map((talla) => (
                                    <th key={talla.id} colSpan="2" style={styles.proportionTh}>{talla.name}</th>
                                  ))}
                              </tr>
                              <tr>
                                <th style={styles.proportionTh}></th>
                                {art.arrayTallas
                                  .sort((a, b) => customSizeOrder.indexOf(a.name) - customSizeOrder.indexOf(b.name))
                                  .map((talla) => (
                                    <React.Fragment key={`h-${talla.id}`}>
                                      <th style={{ ...styles.proportionTh, fontSize: "10px" }}>Cant.</th>
                                      <th style={{ ...styles.proportionTh, fontSize: "10px" }}>EAN</th>
                                    </React.Fragment>
                                  ))}
                              </tr>
                            </thead>
                            <tbody>
                              {art.arrayColores.map((color) => (
                                <tr key={color.id}>
                                  <td style={{ ...styles.proportionTd, fontWeight: "600", backgroundColor: "#f8f9fa" }}>{color.name}</td>
                                  {art.arrayTallas
                                    .sort((a, b) => customSizeOrder.indexOf(a.name) - customSizeOrder.indexOf(b.name))
                                    .map((talla) => {
                                      const prop = art.proporciones.find((p) => p.colorId === color.id && p.sizeId === talla.id);
                                      return (
                                        <React.Fragment key={`${color.id}-${talla.id}`}>
                                          <td style={styles.proportionTd}>
                                            <input
                                              type="number"
                                              min="0"
                                              style={styles.proportionInput}
                                              value={prop?.cantidad || 0}
                                              onChange={(e) => handleProporcionChange(index, color.id, talla.id, "cantidad", e.target.value)}
                                            />
                                          </td>
                                          <td style={styles.proportionTd}>
                                            <input
                                              type="text"
                                              style={styles.eanInput}
                                              value={prop?.ean || ""}
                                              onChange={(e) => handleProporcionChange(index, color.id, talla.id, "ean", e.target.value)}
                                            />
                                          </td>
                                        </React.Fragment>
                                      );
                                    })}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}

            {/* ============== SUMMARY AND SUBMIT ============== */}
            <div style={{ ...styles.grid, gridTemplateColumns: "1fr 1fr", marginTop: "20px", alignItems: "center" }}>
              <div style={styles.summaryBox}>
                <strong>Resumen:</strong> {totalArticulos} artículos, {totalPiezas} piezas totales
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button
                  type="button"
                  style={{ ...styles.button, ...styles.buttonSecondary }}
                  onClick={validateAll}
                >
                  <i className="fas fa-check-circle"></i> Validar
                </button>
                <button
                  type="submit"
                  style={{ ...styles.button, ...styles.buttonSuccess }}
                  disabled={!validaBoton || submitting}
                >
                  {submitting ? (
                    <>
                      <Spinner size="sm" /> Guardando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save"></i> Guardar Todos
                    </>
                  )}
                </button>
                <a href="/ListadoArticulos" style={{ ...styles.button, ...styles.buttonDanger, textDecoration: "none" }}>
                  Cancelar
                </a>
              </div>
            </div>
          </Form>

          {/* ============== MODALS ============== */}
          {/* Global Colors Modal */}
          <Modal size="lg" isOpen={modalGlobalColores} toggle={() => setModalGlobalColores(false)}>
            <ModalHeader toggle={() => setModalGlobalColores(false)}>
              Seleccionar Colores Globales
            </ModalHeader>
            <ModalBody>
              <div style={styles.modalContent}>
                <div style={styles.checkboxGrid}>
                  {colores.sort((a, b) => a.name.localeCompare(b.name)).map((color) => {
                    const isSelected = globalConfig.arrayColores.some((c) => c.id === color._id);
                    return (
                      <label key={color._id} style={{ ...styles.checkboxItem, backgroundColor: isSelected ? "#d4edda" : "#f8f9fa" }}>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={(e) => toggleGlobalColor(color, e.target.checked)}
                        />
                        {color.name}
                      </label>
                    );
                  })}
                </div>
              </div>
            </ModalBody>
          </Modal>

          {/* Global Tallas Modal */}
          <Modal size="lg" isOpen={modalGlobalTallas} toggle={() => setModalGlobalTallas(false)}>
            <ModalHeader toggle={() => setModalGlobalTallas(false)}>
              Seleccionar Tallas Globales
            </ModalHeader>
            <ModalBody>
              <div style={styles.modalContent}>
                <div style={styles.checkboxGrid}>
                  {tallas.sort((a, b) => customSizeOrder.indexOf(a.name) - customSizeOrder.indexOf(b.name)).map((talla) => {
                    const isSelected = globalConfig.arrayTallas.some((t) => t.id === talla._id);
                    return (
                      <label key={talla._id} style={{ ...styles.checkboxItem, backgroundColor: isSelected ? "#d4edda" : "#f8f9fa" }}>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={(e) => toggleGlobalTalla(talla, e.target.checked)}
                        />
                        {talla.name}
                      </label>
                    );
                  })}
                </div>
              </div>
            </ModalBody>
          </Modal>

          {/* Article Colors Modal */}
          <Modal size="lg" isOpen={modalColores} toggle={() => setModalColores(false)}>
            <ModalHeader toggle={() => setModalColores(false)}>
              Seleccionar Colores - Artículo {activeArticuloIndex + 1}
            </ModalHeader>
            <ModalBody>
              <div style={styles.modalContent}>
                <div style={styles.checkboxGrid}>
                  {colores.sort((a, b) => a.name.localeCompare(b.name)).map((color) => {
                    const isSelected = articulos[activeArticuloIndex]?.arrayColores.some((c) => c.id === color._id);
                    return (
                      <label key={color._id} style={{ ...styles.checkboxItem, backgroundColor: isSelected ? "#d4edda" : "#f8f9fa" }}>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={(e) => toggleColoresSelection(color, e.target.checked)}
                        />
                        {color.name}
                      </label>
                    );
                  })}
                </div>
              </div>
            </ModalBody>
          </Modal>

          {/* Article Tallas Modal */}
          <Modal size="lg" isOpen={modalTallas} toggle={() => setModalTallas(false)}>
            <ModalHeader toggle={() => setModalTallas(false)}>
              Seleccionar Tallas - Artículo {activeArticuloIndex + 1}
            </ModalHeader>
            <ModalBody>
              <div style={styles.modalContent}>
                <div style={styles.checkboxGrid}>
                  {tallas.sort((a, b) => customSizeOrder.indexOf(a.name) - customSizeOrder.indexOf(b.name)).map((talla) => {
                    const isSelected = articulos[activeArticuloIndex]?.arrayTallas.some((t) => t.id === talla._id);
                    return (
                      <label key={talla._id} style={{ ...styles.checkboxItem, backgroundColor: isSelected ? "#d4edda" : "#f8f9fa" }}>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={(e) => toggleTallasSelection(talla, e.target.checked)}
                        />
                        {talla.name}
                      </label>
                    );
                  })}
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "50px" }}>
          <h4>No tienes permisos para acceder a esta sección</h4>
        </div>
      )}
    </>
  );
}

export default ArticulosBulkCreate;
